import React, { Component } from 'react'
import LandingPV from './LandingPV'
import AuthA from '../../store/actions/AuthA'

import {connect} from 'react-redux'

class LandingPC extends Component {
  state = {
    user: '',
    password: '',
    mask: true
  }

  togglePasswordMask = () => {
    this.setState({mask: !this.state.mask})
  }
  onUserChange = (event) => {
    this.setState({user: event.target.value})
  }

  onPasswordChange = (event) => {
    this.setState({password: event.target.value})
  }

  login = () => {
    const data = {
      'username': this.state.user,
      'password': this.state.password
    }
    this.props.authFn.login(data)
  }

  signup = () => {
    const email = this.state.user.split('@');
    const username = email[0];
    const data = {
      'email': this.state.user,
      'username': username,
      'password': this.state.password
    }
    this.props.authFn.signup(data)
  }

  render() {
    return (
      <LandingPV
        mask={this.state.mask}
        togglePasswordMask={this.togglePasswordMask}
        login={this.login}
        signup={this.signup}
        auth={this.props.auth}
        loginErr={this.props.loginErr}
        onUserChange={this.onUserChange}
        onPasswordChange={this.onPasswordChange}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    loginErr: state.AuthR.loginErr,
  }
}



export default connect(mapStateToProps, mapDispatchToProps)(LandingPC);
